import React from 'react'
import PropTypes from 'prop-types'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Helmet } from 'react-helmet'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateInput from '../input/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import PPRollsConditions from './conditions'
import PPRollsItems from './items'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const PPRollsEditForm = observer(({ state, selectionState }) => {
  const record = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(defaultConst.ENTNAMES.PPROLLS, 'w')
  const { stageOneRestricted, stageTwoRestricted } = state.timeRestriction.checkEntity(state, record, state.cv.timeRestriction)
  const dateRestriction = state.timeRestriction[state.cv.entityname]
  const origRecord = state.cv.origRecord
  const hasID = record.has('id')

  return (
    <div className='row'>
      <Helmet title={state.__(linkConst.LINK_PPROLLS_SETUP_TITLE).concat(defaultConst.HTML_DIVIDER) + (record.get('id')
        ? (record.has('name') ? record.get('name') : state.__(defaultConst.TITLE_EDIT))
        : state.__(defaultConst.TITLE_CREATE))} />
      <div className='col-sm-12 col-lg-6'>
        <TextInput label={state.__('Name')} attr={'name'} record={record}
          onChange={updateField} errors={errors} disabled={disabled || stageOneRestricted} />
        <DateInput
          label={state.__('valid from')}
          attr={'valid_from'}
          record={record}
          disabled={disabled || stageOneRestricted || (record.has('id') && record.get('valid_from') && moment(record.get('valid_from')).isSame(moment(), 'day'))}
          minDate={dateRestriction.valid_from.minDate}
          onChange={updateField}
          errors={errors} />
        <DateInput
          label={state.__('valid to')}
          attr={'valid_to'}
          disabled={disabled || (stageTwoRestricted && origRecord.valid_to && origRecord.valid_to === record.get('valid_to'))}
          record={record}
          onChange={updateField}
          errors={errors}
          minDate={dateRestriction.valid_to.minDateToday &&
            (!hasID || !record.get('id') || (record.has('valid_from') && record.get('valid_from') &&
            moment(record.get('valid_from')).isSameOrAfter(dateRestriction.valid_to.minDateToday, 'day')))
            ? dateRestriction.valid_to.minDateToday
            : dateRestriction.valid_to.minDate}
        />
      </div>
      <div className='col-sm-12 col-lg-6'>
        <PPRollsConditions store={state} />
      </div>
      <div className='col-sm-12 col-lg-12'>
        <PPRollsItems store={state} />
      </div>
    </div>

  )
})

PPRollsEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const PPRollsEditView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.PPROLLS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView
      store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.PPROLLS, 'w')} >
      <PPRollsEditForm state={store} selectionState={observable.box([])} />
    </EditView>
  )
}
export default PPRollsEditView
